import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    "&:hover": {
      backgroundColor: "#D9DCF0",
    },
    alignItems: "center",
    aspectRatio: "1/1",
    border: `1px solid ${palette.primary.main}`,
    borderRadius: spacing(1.5),
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    padding: spacing(1),
    textAlign: "center",
    transition: ".2s all ease-out",
    width: "100%",
  },

  button__inner_default: {
    "$button:hover &": {
      display: "none",
    },
  },

  button__inner_hover: {
    display: "none",

    "$button:hover &": {
      display: "flex",
    },
  },
  icon: {
    color: palette.primary.main,
  },
  text: {
    color: palette.primary.main,
    fontSize: 16,
    fontWeight: 500,
  },
}));
